import React, { Component } from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';

import Form from 'react-jsonschema-form';
import SweetAlert from 'react-bootstrap-sweetalert';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AboutActions from './redux/AboutActions';
import widgets from '../../lib/widgets';
import fields from '../../lib/fields';

import { Editor } from '@tinymce/tinymce-react';

const schema = {
    definitions: {},
    $schema: 'http://json-schema.org/draft-07/schema#',
    $id: 'http://example.com/root.json',
    type: 'object',
    required: ['name', 'image', 'bio'],
    properties: {
        name: {
            $id: '#/properties/name',
            type: 'string',
            title: 'Nombre',
            default: '',
            examples: ['String'],
            pattern: '^(.*)$'
        },
        image: {
            $id: '#/properties/image',
            type: 'string',
            title: 'Imagen',
            default: '',
            examples: ['String'],
            pattern: '^(.*)$'
        },
        bio: {
            $id: '#/properties/bio',
            type: 'string',
            title: 'Bio',
            default: '',
            examples: ['String'],
            pattern: '^(.*)$'
        }
    }
};

const uiSchema = {
    image: {
        'ui:field': 'UploadField'
    },
    bio: {
        'ui:widget': props => {
            return (
                <Editor
                    init={{
                        min_height: 500
                    }}
                    initialValue={props.value}
                    onChange={event =>
                        props.onChange(event.target.getContent())
                    }
                />
            );
        }
    }
};

const log = type => console.log.bind(console, type);

class AboutForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.match.params.id,
            openConfirm: false,
            openSuccess: false
        };

        console.log('Props', props.match.params);
    }

    componentWillMount() {
        if (this.state.id !== 'create') this.props.findById(this.state.id);
    }

    onSubmit = ({ formData }) => {
        let _this = this;
        console.log('Data submitted: ', formData);
        if (
            formData.password === '' ||
            formData.password === undefined ||
            formData.password == null
        )
            delete formData.password;

        if (this.state.id !== 'create') {
            this.props.update(formData.id, formData).then(function() {
                _this.props.history.push('/admin/about');
            });
        } else {
            this.props.create(formData).then(function() {
                _this.props.history.push('/admin/about');
            });
        }
    };

    onDelete(confirm = false) {
        let _this = this;
        if (confirm) {
            this.props.remove(this.state.id).then(function() {
                _this.props.history.push('/admin/about');
            });
        } else {
            this.setState({ openConfirm: true });
        }
    }

    onBlur = (id, value) => {
        console.log('Data submitted: ', this.state.formData);
    };

    render() {
        let { history, About } = this.props;
        let { id, openConfirm, openSuccess } = this.state;
        return (
            <div className="main-content">
                {openConfirm && (
                    <SweetAlert
                        warning
                        style={{ display: 'block', marginTop: '-100px' }}
                        title="¿Estás Seguro?"
                        onConfirm={() => this.onDelete(true)}
                        onCancel={() => this.setState({ openConfirm: false })}
                        confirmBtnBsStyle="info"
                        cancelBtnBsStyle="danger"
                        confirmBtnText="Si, borrar!"
                        cancelBtnText="Cancelar"
                        showCancel
                    >
                        No podrás desaser está opción!
                    </SweetAlert>
                )}

                {openSuccess && (
                    <SweetAlert
                        success
                        style={{ display: 'block', marginTop: '-100px' }}
                        title="Listo!"
                        confirmBtnBsStyle="info"
                        onConfirm={() => this.setState({ openSuccess: false })}
                    >
                        Se ha actualizado correctamente!
                    </SweetAlert>
                )}

                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title={<legend>Editar registro</legend>}
                                content={
                                    <div>
                                        <Form
                                            schema={schema}
                                            widgets={widgets}
                                            fields={fields}
                                            uiSchema={uiSchema}
                                            onSubmit={this.onSubmit}
                                            onBlur={this.onBlur}
                                            formData={About.formData}
                                            onError={log('errors')}
                                        >
                                            <div>
                                                <Button
                                                    bsStyle="success"
                                                    type="submit"
                                                    className="btn-fill"
                                                >
                                                    Guardar
                                                </Button>{' '}
                                                <Button
                                                    bsStyle="default"
                                                    onClick={() =>
                                                        history.push(
                                                            '/admin/about'
                                                        )
                                                    }
                                                >
                                                    Cancelar
                                                </Button>
                                                <div className="pull-right">
                                                    {id !== 'create' ? (
                                                        <Button
                                                            bsStyle="danger"
                                                            onClick={() =>
                                                                this.onDelete(
                                                                    false
                                                                )
                                                            }
                                                        >
                                                            Borrar
                                                        </Button>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </Form>

                                        <div className="clearfix" />
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        About: state.About
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(AboutActions, dispatch);
};

const AboutConnect = connect(
    mapStateToProps,
    mapDispatchToProps
)(AboutForm);

export default AboutConnect;



// WEBPACK FOOTER //
// ./src/views/About/AboutForm.jsx